import { LOCALE_ID, NgModule } from '@angular/core';
import {
    CommonModule,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    HashLocationStrategy,
    LocationStrategy,
} from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PortalPagosComponent } from './pages/portal-pagos/portal-pagos.component';
import { PI_MODULES } from './pages/base/prime-modules';
import { DashboardComponent } from './pages/home/dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IndexDBService } from './services/indexd-db/indexd-db.service';
import { ImpresionModule } from './pages/impresion/impresion.module';
import { TreeTableModule } from 'primeng/treetable';

@NgModule({
    declarations: [AppComponent, PortalPagosComponent, DashboardComponent],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        CommonModule,
        BrowserAnimationsModule,
        ImpresionModule,
        TreeTableModule,
        ...PI_MODULES,
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LOCALE_ID, useValue: 'es-PY' },
        DecimalPipe,
        CurrencyPipe,
        MessageService,
        ConfirmationService,
        DatePipe,
        IndexDBService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
